import React from 'react';
import { DesignHeader } from './DesignHeader';
import { ContentLayout } from '../ui/ContentLayout';
import { RequiredActions } from './caseStudies/RequiredActions';
export function CaseStudyContent({
  activePage,
  onNavigate,
  onOpenMobileMenu,
  parentDestination
}: {
  activePage: string;
  onNavigate: (page: string) => void;
  onOpenMobileMenu: () => void;
  parentDestination: 'complexity' | 'work';
}) {
  const slug = activePage.replace(/^work\//, '');
  const renderContent = () => {
    switch (slug) {
      case 'required-actions':
      default:
        return <RequiredActions data-id="element-70" />;
    }
  };
  return <div className="flex-1 bg-white text-black flex flex-col min-h-screen" data-id="element-71">
      <DesignHeader onNavigate={onNavigate} onOpenMobileMenu={onOpenMobileMenu} closeTarget={parentDestination} data-id="element-72" />

      <div className="flex-1 overflow-y-auto" data-id="element-73">
        <ContentLayout data-id="element-74">{renderContent()}</ContentLayout>
      </div>
    </div>;
}